export enum ShippingRateTerritorialScope {
    National,
    Provincial,
    PostalCode,
}
